import HighStarProviderReview from './HighStarProviderReview';

export default HighStarProviderReview;
